import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const color = JSON.parse(localStorage.getItem('cltObj'))?.color || '#90e5fc';

const borderColor = color;
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderBottomColor: color,
    backgroundColor: '#4a86e8',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 20,
    textAlign: 'center',
    fontStyle: 'bold',
    flexGrow: 1,
    color: "#fff",
  },
  description: {
    width: '50%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    lineHeight: 0,
  },
  unite: {
    width: '10%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    lineHeight: 0,
  },
  quantite: {
    width: '10%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    lineHeight: 0,
  },
  coutUnitaire: {
    width: '15%',
    lineHeight: 0,
  },
  montant: {
    width: '15%',
    lineHeight: 0,
  },
});

const InvoiceTableHeader = ({ translations }) => (
  <View style={styles.container}>
    <Text style={styles.description}>{translations.description}</Text>
    <Text style={styles.unite}>{translations.unite}</Text>
    <Text style={styles.quantite}>{translations.quantite}</Text>
    <Text style={styles.coutUnitaire}>{translations.coutUnitaire}</Text>
    <Text style={styles.montant}>{translations.montant}</Text>
  </View>
);

export default InvoiceTableHeader;